import type { IOnboardingStepText } from '../../types/IOnboardingStepText'

export const auditsTexts: Record<string, IOnboardingStepText> = {
  'audits.intro': {
    title: 'Аудиты',
    text: 'Плановые и внеплановые проверки подразделений: от назначения аудиторов до отчёта о несоответствиях.',
  },
  'audits.createAudit': {
    title: 'Новый аудит',
    text: 'Укажите даты, отделения, руководителя и аудиторов. Аудиторов можно взять готовой группой.',
  },
  'audits.nav': {
    title: 'Разделы',
    text: 'Реестр аудитов, группы аудиторов, несоответствия, статистика, график проверок и архив.',
  },
  'audits.register.search': {
    title: 'Поиск',
    text: 'Введите слово или номер и нажмите Enter.',
  },
  'audits.register.flags': {
    title: 'Быстрые фильтры',
    text: 'Просроченные аудиты и те, где ждут именно вас. Такие строки выделены цветом.',
  },
  'audits.register.resetFilters': {
    title: 'Сброс фильтров',
    text: 'Возвращает реестр к виду по умолчанию.',
  },
  'audits.register.filters': {
    title: 'Фильтры колонок',
    text: 'Значок в заголовке колонки открывает фильтр по ней.',
  },
  'audits.register.demoRow': {
    title: 'Карточка аудита',
    text: 'Клик по строке открывает карточку аудита. Откроем учебную.',
  },
  'audits.card.start': {
    title: 'Начать проверку',
    text: 'Доступно аудиторам, пока аудит не завершён. Откроет чек-лист проверки по отделению.',
  },
  'audits.card.downloads': {
    title: 'Карточка аудита',
    text: 'Скачать карточку аудита в PDF или Word.',
  },
  'audits.card.checklist': {
    title: 'Чек-лист',
    text: 'Чек-лист аудитора для проверки на бумаге: выберите аудитора и формат.',
  },
  'audits.card.nonconformities': {
    title: 'Несоответствия',
    text: 'Найденные нарушения и работа по их устранению.',
  },
  'audits.card.edit': {
    title: 'Редактирование',
    text: 'Изменить даты, отделения и состав аудиторов.',
  },
  'audits.card.departments': {
    title: 'Отделения',
    text: 'Каждая вкладка — проверяемое отделение и назначенные на него аудиторы.',
  },
  'audits.card.assignments': {
    title: 'Назначения',
    text: 'Кто что проверяет и с каким результатом. Руководитель аудита открывает проверку аудитора кликом по строке.',
  },
  'audits.process.intro': {
    title: 'Проведение проверки',
    text: 'Здесь аудитор отвечает на вопросы чек-листа по отделению. Аудитор попадает сюда кнопкой «Начать проверку», руководитель — кликом по строке назначения.',
  },
  'audits.process.criteria': {
    title: 'Предметы проверки',
    text: 'Каждая вкладка — предмет проверки. Когда отвечены все вопросы предмета, внизу появится «Завершить проверку»: после неё ответы не изменить, а галочка на вкладке покажет, что предмет закрыт.',
  },
  'audits.process.questions': {
    title: 'Вопросы',
    text: 'Отвеченные вопросы свёрнуты и отмечены значком результата, неотвеченные раскрыты.',
  },
  'audits.process.comment': {
    title: 'Наблюдение аудитора',
    text: 'Что увидели на месте. Сюда же прикрепляются фото и документы — кнопкой или вставкой из буфера (Ctrl+V).',
  },
  'audits.process.decision': {
    title: 'Результат',
    text: 'Соответствует, не соответствует или не применимо. При «Не соответствует» нужно указать градацию и категорию действия, можно добавить рекомендации и срок устранения. Выбор фиксируется кнопкой «Подтвердить выбор».',
  },
  'audits.nonconformities.intro': {
    title: 'Несоответствия',
    text: 'Нарушения, найденные на аудитах, и отчёты об их устранении.',
  },
  'audits.groups.intro': {
    title: 'Группы аудиторов',
    text: 'Готовые составы аудиторов с предметами проверки — их подставляют при создании аудита.',
  },
  'audits.groups.create': {
    title: 'Новая группа',
    text: 'Соберите аудиторов и укажите, что проверяет каждый.',
  },
  'audits.archive.intro': {
    title: 'Архив',
    text: 'Завершённые проверки прошлых периодов.',
  },
  'audits.table.search': {
    title: 'Поиск',
    text: 'Введите слово или номер и нажмите Enter.',
  },
  'audits.nonconformities.table': {
    title: 'Несоответствия',
    text: 'Клик по строке открывает форму несоответствия. Значок в заголовке колонки открывает фильтр по ней.',
  },
  'audits.groups.table': {
    title: 'Группы',
    text: 'Клик по строке открывает группу: аудиторов и предметы проверки. Значок в заголовке колонки открывает фильтр по ней.',
  },
  'audits.archive.table': {
    title: 'Архив',
    text: 'Значок в заголовке колонки открывает фильтр по ней.',
  },
  'audits.table.resetFilters': {
    title: 'Сброс фильтров',
    text: 'Возвращает таблицу к виду по умолчанию.',
  },
  'audits.chart.calendar': {
    title: 'График проверок',
    text: 'Аудиты по отделениям и месяцам. Клик по ячейке отделения создаёт проверку в этом месяце, клик по аудиту открывает его. Красным отмечены просроченные.',
  },
  'audits.chart.create': {
    title: 'Новая проверка',
    text: 'Запланировать аудит прямо из графика.',
  },
  'audits.chart.datePicker': {
    title: 'Дата в календаре',
    text: 'Клик по дате показывает на графике выбранный месяц и задаёт число начала: клик по ячейке в матрице создаст проверку на это число. В видах «Месяц» и «Неделя» проверка создаётся на кликнутый день. Прошедшую дату форма примет, но предупредит.',
  },
  'audits.chart.types': {
    title: 'Виды аудита',
    text: 'Оставьте на графике только нужные виды проверок.',
  },
}
